export default __webpack_public_path__ + "static/media/tap_here_bottom_ios_18.2a6b9397.png";